angular.module("digitalLeasing.module").component("plafondRequestData", {
    templateUrl: "ng/components/digitalLeasing/plafondLoading/plafondRequestData/plafondRequestData.view.html",
    bindings: {
        model: "=", //preventivo
        onStructureChanges: "&",
        vendor: "=",
        customer: "=",
        validateCli: "&",
        invalidateCli: "&"
    },
    controllerAs: "plafondRequestDataCtrl",
    controller: PlafondRequestDataController
});

function PlafondRequestDataController($financialApiService, ProdottiConvenzione, $timeout, $giuridicVersion) {
    var self = this;

    self.$onInit = function () {
        self.supportModel = {
            options: ["AZIENDA"],
            defaultOptions: "AZIENDA",
            valoriMinimi: [],
            valoriMassimi: []
        }
        self.additionalRecipients = false;
        self.showRecipientsTable = false;
        self.numberOfCharMax = 20;
        self.produtsResponseList = [];
        self.productSelectedList = [];
        self.productList = {
            principale: false,
            cdProdotto: "",
            ammetteKm0: false,
            importoAffidamento: 0
        };

        if (self.model.richiestaConvenzionePlafond.clientiDestinatari.length > 0) {
            self.additionalRecipients = true;
            self.showRecipientsTable = true;
        }

        getValidationsByProducts();
        checkAndEnableTooltip();
        validationDestClient();
    };

    self.handleChange = function (property, value) {
        switch (property) {
            case "prodottiConvenzione":
                self.productList = value;
                saveProductsOnModel(self.productList, false);
                break;
            case "clientiDest":
                if (!value) {
                    if (self.model.richiestaConvenzionePlafond.clientiDestinatari.length > 0) {
                        self.model.richiestaConvenzionePlafond.clientiDestinatari = [];
                    }
                }
                break;
            default:
                self.model.richiestaConvenzionePlafond[property] = value;
                break;
        }

        self.onStructureChanges({
            newRequestDataStructure: self.model
        });
        validationDestClient();
    };

    self.onCheckboxChange = function (field) {
        field.allProducts = !field.allProducts;

        if (field.allProducts) {
            saveProductsOnModel(self.produtsResponseList, true);

            self.onStructureChanges({
                newRequestDataStructure: self.model
            });

        } else {
            self.model.richiestaConvenzionePlafond.prodottiConvenzione = [];
        }
    }

    self.exportValidityCustomerDigital = function (validity) {
        self.customerDigitalValidity = validity;
        validationDestClient();
    }

    self.getSubject = function (value) {
        if (value && self.customerDigitalValidity) {
            self.showRecipientsTable = true;
            if (self.model.richiestaConvenzionePlafond.clientiDestinatari.length > 0) {
                var index = self.model.richiestaConvenzionePlafond.clientiDestinatari.findIndex(function (el) {
                    return value.riUserG.piva == el.riUserG.piva;
                });
                if (index != -1) {
                    self.model.richiestaConvenzionePlafond.clientiDestinatari.splice(index, 1);
                    populateCliDest(value);
                } else {
                    populateCliDest(value);
                }
            } else {
                if (self.customerDigitalValidity) {
                    populateCliDest(value);
                }
            }
            validationDestClient();
        }
    }

    var getValidationsByProducts = function () {
        $financialApiService
            .validationsByProducts()
            .then(function (protuctsResponse) {
                self.produtsResponseList = protuctsResponse.sort(function (a, b) {
                    if (a.cdProdotto > b.cdProdotto) {
                        return 1
                    } else {
                        return -1
                    }
                });

                if (self.model.richiestaConvenzionePlafond.prodottiConvenzione.length > 0) {
                    self.productSelectedList = self.model.richiestaConvenzionePlafond.prodottiConvenzione;
                    //self.productSelectedList.forEach(function (element) {
                    // if (element.cdTipoProdotto === "AVC") {
                    //     element.dsProdotto.replace(/>/g, "&lt;");
                    // }
                    // if (element.cdTipoProdotto === "AVI") {
                    //     element.dsProdotto.replace(/</g, "&gt;");
                    // }
                    //});
                } else {
                    self.productSelectedList = protuctsResponse.filter(function (productSelected) {
                        return productSelected.cdProdotto === self.model.prodotto.id;
                    })
                }

                self.produtsResponseList.forEach(function (el) {
                    if (el.cdTipoProdotto === "AVC") {
                        el.dsProdotto = "AUTOVEICOLI INDUSTRIALI min 35 Q.";
                    }
                    if (el.cdTipoProdotto === "AVI") {
                        el.dsProdotto = "AUTOVEICOLI INDUSTRIALI mag 35 Q.";
                    }
                    self.supportModel.valoriMassimi.push(el.impFinanziabileMax);
                    self.supportModel.valoriMinimi.push(el.impFinanziabileMin)
                })

                saveProductsOnModel(self.productSelectedList, false);

                $timeout(function () {
                    $("a.ui.label").filter(function () {
                        return $(this).text().toLowerCase().substring(0, 3) === self.model.prodotto.id.toLowerCase();
                    }).addClass('disabled-item')

                    $("a.ui.label").addClass('elementStyle');
                    $('.ui.search.dropdown .menu').addClass('size-dropdown');
                }, 3000);
            })
            .catch(function (error) {
                console.error(error);
            });
    }

    var saveProductsOnModel = function (list, allProduct) {
        self.model.richiestaConvenzionePlafond.prodottiConvenzione = [];
        if (!allProduct) {
            list.forEach(function (element) {
                element.selected = true;

                self.model.richiestaConvenzionePlafond.prodottiConvenzione.push(ProdottiConvenzione.build({
                    cdProdotto: element.cdProdotto,
                    principale: self.model.prodotto.id === element.cdProdotto ? true : false
                }));

                self.model.richiestaConvenzionePlafond.prodottiConvenzione.forEach(function (el) {
                    if (element.cdProdotto === 'AVT') {
                        el.ammetteKm0 = true;
                    }
                    if (el.cdProdotto === element.cdProdotto) {
                        el.validations.anticipo.minimo.valore = element.canoniAntMin;
                        //el.validations.anticipo.massimo.valore = element.canoniAntMax;

                        if (self.model.pianoFinanziario.anticipo.id === 'CEQ') {
                            el.validations.anticipo.massimo.valore = self.model.pianoFinanziario.anticipo.numeroCanoni;
                        } else {
                            el.validations.anticipo.massimo.valore = element.canoniAntMax;
                        }

                        el.validations.durataMesi.minimo.valore = element.durataMin;
                        el.validations.durataMesi.massimo.valore = element.durataMax;
                        el.validations.anticipoPerc.minimo.valore = element.percAnticipoMin;
                        el.validations.anticipoPerc.massimo.valore = element.percAnticipoMax;
                        el.validations.riscattoPerc.minimo.valore = element.percRiscattatoMin;
                        el.validations.riscattoPerc.massimo.valore = element.percRiscattatoMax;
                        el.validations.spreadNetto.minimo.valore = self.model.pianoFinanziario.tassiCalcolati.spreadNetto;
                        el.validations.importo.massimo.valore = element.impFinanziabileMax;
                        el.validations.importo.minimo.valore = element.impFinanziabileMin;
                    }
                })
            })
        } else {
            self.productList.cdProdotto = "***";
            self.productList.principale = true;
            self.productList.importoAffidamento = self.model.importo;
            self.model.richiestaConvenzionePlafond.prodottiConvenzione.push(ProdottiConvenzione.build(self.productList));

            self.model.richiestaConvenzionePlafond.prodottiConvenzione.forEach(function (el) {
                el.validations.anticipo.minimo.valore = 0;
                if (self.model.pianoFinanziario.anticipo.id === 'CEQ') {
                    el.validations.anticipo.massimo.valore = self.model.pianoFinanziario.anticipo.numeroCanoni;
                } else {
                    el.validations.anticipo.massimo.valore = 0;
                }
                el.validations.durataMesi.minimo.valore = self.model.pianoFinanziario.durataMesi;
                el.validations.durataMesi.massimo.valore = 999;
                el.validations.anticipoPerc.minimo.valore = 0;
                el.validations.anticipoPerc.massimo.valore = self.model.pianoFinanziario.anticipo.percentuale;
                el.validations.riscattoPerc.minimo.valore = 0;
                el.validations.riscattoPerc.massimo.valore = self.model.pianoFinanziario.riscatto.percentuale;
                el.validations.spreadNetto.minimo.valore = self.model.pianoFinanziario.tassiCalcolati.spreadNetto;
                el.validations.spreadNetto.massimo.valore = 100;
                el.validations.importo.massimo.valore = Math.max.apply(Math, self.supportModel.valoriMinimi);
                el.validations.importo.minimo.valore = Math.min.apply(Math, self.supportModel.valoriMinimi);
            })
        }
    }

    var checkAndEnableTooltip = function () {
        if (self.vendor) {
            if (self.vendor.riUserG.ragioneSociale && self.vendor.riUserG.ragioneSociale.length > self.numberOfCharMax) {
                self.enableToltipVendor = true;
            }

            if (self.vendor.filiale.ragioneSocialeBanca) {
                var infoFiliale = self.vendor.filiale.ragioneSocialeBanca + " " + self.vendor.filiale.descrizione;
                if (infoFiliale && infoFiliale > self.numberOfCharMax) {
                    self.enableToltipFiliale = true;
                }
            }

            if (self.vendor.clientManager.ragioneSociale && self.vendor.clientManager.ragioneSociale.length > self.numberOfCharMax) {
                self.enableToltipClientManager = true;
            }
        }

        if (self.customer) {
            if (self.customer.metadata.riUserG.ragioneSociale && self.customer.metadata.riUserG.ragioneSociale.length > self.numberOfCharMax) {
                self.enableToltipClient = true;
            }
        }
    }

    var populateCliDest = function (value) {
        if ($giuridicVersion.checkIfInd(value.riUserG.formaGiuridica)) {
            self.model.richiestaConvenzionePlafond.clientiDestinatari.push({
                riUserG: value.riUserG,
                riUserF: value.riUserF,
                isPersona: false
            });
        } else {
            self.model.richiestaConvenzionePlafond.clientiDestinatari.push({
                riUserG: value.riUserG,
                isPersona: false
            });
        }
    }

    var validationDestClient = function () {
        if (self.additionalRecipients) {
            var test = (self.customerDigitalValidity || self.showRecipientsTable) &&
                self.model.richiestaConvenzionePlafond.clientiDestinatari.length > 0;

            if (test) {
                self.validateCli();
            } else {
                self.invalidateCli();
            }
        } else {
            self.validateCli();
        }
    }
}